import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import {
  getAccessToken,
  getApiversion,
  getRefreshToken,
  getTokenExpires,
  getUser,
} from './AuthSelectors';
import { clearAuthState, setAuthState } from './AuthSlice';
import { LoginRes } from '@models/User';
import { RootState } from '@root/rootReducer';
export interface AuthPageHookResult {
  // AuthState: ReturnType<typeof getAuthState>;
  accessToken: ReturnType<typeof getAccessToken>;
  refreshToken: ReturnType<typeof getRefreshToken>;
  tokenExpires: ReturnType<typeof getTokenExpires>;
  user: ReturnType<typeof getUser>;
  apiVersion: ReturnType<typeof getApiversion>;

  isElectron: boolean;

  updateAuthState: (newState: LoginRes) => void;
  resetAuthState: () => void;
}

export const useAuthPage = (): AuthPageHookResult => {
  const dispatch = useDispatch();

  // 값 읽기
  // const AuthState = useSelector(getAuthState, shallowEqual);
  const accessToken = useSelector(getAccessToken, shallowEqual);
  const refreshToken = useSelector(getRefreshToken, shallowEqual);
  const tokenExpires = useSelector(getTokenExpires, shallowEqual);
  const user = useSelector(getUser, shallowEqual);
  const apiVersion = useSelector(getApiversion, shallowEqual);

  const isElectron = useSelector((state: RootState) => state.env.isElectron,shallowEqual);

  // 값 변경
  const updateAuthState = useCallback(
    (newState: LoginRes) => {
      dispatch(setAuthState(newState));
    },
    [dispatch],
  );

  const resetAuthState = useCallback(() => {
    dispatch(clearAuthState());
  }, [dispatch]);

  return useMemo(
    () => ({
      // AuthState,
      accessToken,
      refreshToken,
      tokenExpires,
      user,
      apiVersion,

      isElectron,

      updateAuthState,
      resetAuthState,
    }),
    [
      // AuthState,
      accessToken,
      refreshToken,
      tokenExpires,
      user,
      apiVersion,

      isElectron,

      updateAuthState,
      resetAuthState,
    ],
  );
};
